"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TileDataContext_1 = require("../TileDataContext");
var react_1 = require("react");
var usePriceDrop_1 = __importDefault(require("../../hooks/usePriceDrop"));
var react_2 = __importDefault(require("react"));
var formatAndDropDecimal_1 = __importDefault(require("../formatAndDropDecimal"));
var NewPriceIcon_1 = __importDefault(require("../../icons/NewPriceIcon"));
var Terms_1 = __importDefault(require("./Terms"));
var useDiscount = function () {
    var _a = (0, TileDataContext_1.useTileDataContext)().tileData.price, total = _a.total, totalDiscountAmount = _a.totalDiscountAmount, discounts = _a.discounts;
    var discountedPrice = total !== null && total !== void 0 ? total : 99999;
    var totalDiscount = totalDiscountAmount !== null && totalDiscountAmount !== void 0 ? totalDiscountAmount : 0;
    return (0, react_1.useMemo)(function () {
        var _a;
        var tradeIncentiveDiscount = discounts.find(function (discount) { return (discount === null || discount === void 0 ? void 0 : discount.type) === 'TradeIncentive'; });
        var hasOtherDiscount = discounts.find(function (discount) { return (discount === null || discount === void 0 ? void 0 : discount.type) !== 'TradeIncentive'; });
        var tradeIncentive = (_a = tradeIncentiveDiscount === null || tradeIncentiveDiscount === void 0 ? void 0 : tradeIncentiveDiscount.amount) !== null && _a !== void 0 ? _a : 0;
        return {
            discounts: discounts,
            discountedPrice: discountedPrice,
            hasDiscount: totalDiscount > 0,
            hasOtherDiscount: hasOtherDiscount,
            totalDiscount: totalDiscount,
            tradeIncentive: tradeIncentive
        };
    }, [discounts, discountedPrice, totalDiscount]);
};
function PricingAndTerms() {
    var _a = useDiscount(), discountedPrice = _a.discountedPrice, totalDiscount = _a.totalDiscount, hasDiscount = _a.hasDiscount;
    var _b = (0, usePriceDrop_1.default)(), getPriceDrop = _b.getPriceDrop, restrictedState = _b.restrictedState;
    var tileData = (0, TileDataContext_1.useTileDataContext)().tileData;
    var showPriceDrop = getPriceDrop(tileData).showPriceDrop;
    var showOriginalPrice = hasDiscount || showPriceDrop;
    var _c = tileData.previousPrice, previousPrice = _c === void 0 ? 0 : _c;
    return (react_2.default.createElement("div", { className: "flex flex-row justify-between" },
        react_2.default.createElement("div", { className: "flex h-full flex-col justify-end", "data-qa": "pricing" },
            react_2.default.createElement("div", { className: "t-body-s flex gap-4 text-grey-5" },
                showPriceDrop && !restrictedState ? 'was' : '',
                showOriginalPrice ? (react_2.default.createElement("div", { "data-qa": "original-price", className: "line-through" },
                    "$",
                    showPriceDrop
                        ? (0, formatAndDropDecimal_1.default)(previousPrice)
                        : (0, formatAndDropDecimal_1.default)(discountedPrice + totalDiscount))) : null),
            react_2.default.createElement("div", { "data-qa": "price", className: "flex items-center gap-8 text-2xl font-bold" },
                showPriceDrop && react_2.default.createElement(NewPriceIcon_1.default, { "data-qa": "new-price-icon" }),
                "$",
                (0, formatAndDropDecimal_1.default)(discountedPrice))),
        react_2.default.createElement(Terms_1.default, null)));
}
exports.default = PricingAndTerms;
//# sourceMappingURL=PricingAndTerms.js.map